import React, { useEffect, useState } from 'react';
import { motion, useAnimationControls } from 'framer-motion';
interface BurnoutCardProps {
  value: number;
  trend: string;
  isInView: boolean;
  title?: string;
}
const ProgressBar = ({
  progress
}: {
  progress: number;
}) => <div className="absolute bottom-8 w-[200px]" data-id="element-169">
    <div className="h-4 rounded-full bg-[#E5E7EB] overflow-hidden" data-id="element-170">
      <motion.div className="absolute inset-y-0 left-0 bg-[#2ECC71]" initial={{
      width: 0
    }} animate={{
      width: `${progress}%`
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-171" />
    </div>
  </div>;
export const BurnoutCard = ({
  value,
  trend,
  isInView,
  title
}: BurnoutCardProps) => {
  const [displayValue, setDisplayValue] = useState(0);
  const badgeControls = useAnimationControls();
  useEffect(() => {
    if (!isInView) {
      setDisplayValue(0);
      return;
    }
    let startTime: number;
    const duration = 600; // 0.6s for the animation
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      setDisplayValue(Math.round(progress * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        badgeControls.start({
          scale: 1,
          opacity: 1
        });
      }
    };
    const animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isInView, value]);
  return <div className="flex items-center justify-center relative" style={{
    width: '280px',
    height: '160px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    backdropFilter: 'blur(16px)',
    boxShadow: '0 12px 32px rgba(0,0,0,0.10), 0 4px 8px rgba(0,0,0,0.06)',
    border: '4px solid transparent',
    backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), linear-gradient(to right, rgba(224, 215, 255, 0.4), rgba(183, 233, 233, 0.4))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box'
  }} data-id="element-172">
      {/* Background overlay */}
      <div className="absolute inset-0 rounded-lg" style={{
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(15px)'
    }} data-id="element-173" />
      {title && <div className="absolute top-3 left-4 text-sm font-medium text-gray-600" data-id="element-174">
          {title}
        </div>}
      {/* Value */}
      <div className="text-[48px] font-bold text-[#6D5BD0] relative z-10 -mt-12" style={{
      fontFamily: 'Inter',
      fontFeatureSettings: '"tnum" 1'
    }} data-id="element-175">
        {displayValue}
      </div>
      {/* Progress Bar */}
      {isInView && <ProgressBar progress={value} data-id="element-176" />}
      {/* Risk Badge */}
      <motion.div className="absolute top-3 right-3 flex items-center bg-emerald-500/10 px-2 py-0.5 rounded-full z-20" initial={{
      scale: 0.8,
      opacity: 0
    }} animate={badgeControls} transition={{
      duration: 0.2,
      ease: 'easeOut'
    }} data-id="element-177">
        <span className="text-emerald-600 text-xs font-medium" data-id="element-178">Low Risk</span>
      </motion.div>
    </div>;
};